// extracted by mini-css-extract-plugin
export const main = "layout-module--main--ucOG4";